package fr.frux.shared.data.local

/**
 * Copie locale de la pyramide de regroupements (#622). Le payload est le JSON brut tel que servi :
 * le decodage reste du ressort du depot, qui sait aussi si le schema a change depuis l'ecriture.
 * [checkedAtMillis] est la derniere verification aupres du serveur, un 304 compris.
 */
data class CachedClusterPyramid(
    val etag: String?,
    val payload: String,
    val checkedAtMillis: Long,
)

interface ClusterPyramidLocalDataSource {
    /** Rend null si aucune copie n'est disponible (ou lisible). */
    suspend fun read(): CachedClusterPyramid?

    suspend fun write(
        etag: String?,
        payload: String,
        checkedAtMillis: Long,
    )

    /** Un 304 confirme la copie : seule la date de verification avance, sans copie rien n'est cree. */
    suspend fun touch(checkedAtMillis: Long)
}

/** Repli sans stockage : jamais de copie, ecritures ignorees. */
object NoOpClusterPyramidLocalDataSource : ClusterPyramidLocalDataSource {
    override suspend fun read(): CachedClusterPyramid? = null

    override suspend fun write(
        etag: String?,
        payload: String,
        checkedAtMillis: Long,
    ) = Unit

    override suspend fun touch(checkedAtMillis: Long) = Unit
}
